import {
  DOWNLOAD_COMPLETED,
  GET_DOWNLOADS,
  GET_DOWNLOADS_FAILED,
  GET_DOWNLOADS_SUCCESS,
  HIDE_DOWNLOAD_COMPLETED_MODAL,
  OPEN_DOWNLOAD_COMPLETED_MODAL,
} from "./actionTypes"

const INIT_STATE = {
  loading: false,
  error: "",
  downloads: [],
  downloadCompletedModalIsOpen: false,
  currentDownload: null,
}

const Downloads = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DOWNLOADS:
      return {
        ...state,
        loading: true,
      }
    case GET_DOWNLOADS_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_DOWNLOADS_SUCCESS:
      return {
        ...state,
        downloads: action.payload,
        loading: false,
      }
    case OPEN_DOWNLOAD_COMPLETED_MODAL:
      return {
        ...state,
        downloadCompletedModalIsOpen: true,
      }
    case HIDE_DOWNLOAD_COMPLETED_MODAL:
      return {
        ...state,
        downloadCompletedModalIsOpen: false,
        currentDownload: null,
      }
    case DOWNLOAD_COMPLETED:
      if (!action.payload || typeof action.payload !== "object") {
        return state
      }
      const prevDownloads = Array.isArray(state.downloads)
        ? state.downloads
        : []
      return {
        ...state,
        currentDownload: action.payload,
        downloads: [action.payload, ...prevDownloads],
      }
    default:
      return state
  }
}

export default Downloads
